import { PluginKey } from '@atlaskit/editor-prosemirror/state';

// A new value requests hydration after initialization, document replacement, or source loading.
export const connectorSourceHydrationKey: PluginKey<object> = new PluginKey(
	'connectorSourceHydration',
);
